<header
  appScrollNav
  #header
  id="top"
  class="header"
  [nav]="nav"
  [class.light-background]="!isHomePage"
  style="z-index: 20"
>
  <div class="header-container">
    <div class="header-logo">
      <a
        aria-label="CaseActive home"
        class="top-icon"
        accesskey="h"
        [routerLink]="language === 'en' ? ['/'] : ['/', language]"
        (click)="scrollPageToTop()"
      >
        <img
          width="195"
          height="35"
          alt="caseactive full logo"
          class="top-logo full"
          loading="eager"
          src="images/caseactive-full-logo.png"
        />
        <img
          width="28"
          height="23"
          alt="caseactive small logo"
          class="top-logo short"
          loading="eager"
          src="images/logo-short.png"
        />
      </a>
    </div>
    <nav #nav class="navbar">
      <ul class="navbar-pages" [class.opened]="isMobileMenuShown">
        <li class="navbar-pages__item">
          <a
            class="link"
            routerLinkActive="active"
            [routerLink]="
              language === 'en' ? ['/overview'] : ['/', language, 'overview']
            "
            >{{ 'Overview' | translate }}</a
          >
        </li>
        <li class="navbar-pages__item">
          <a
            class="link"
            routerLinkActive="active"
            [routerLink]="
              language === 'en' ? ['/compare'] : ['/', language, 'compare']
            "
            >{{ 'Compare' | translate }}</a
          >
        </li>
        <li class="navbar-pages__item">
          <a
            class="link"
            routerLinkActive="active"
            [routerLink]="
              language === 'en' ? ['/pricing'] : ['/', language, 'pricing']
            "
            >{{ 'Pricing' | translate }}</a
          >
        </li>
        <li class="navbar-pages__item dropdown">
          <span
            tabindex="0"
            [class.active]="resourcesRoute"
            class="link dropdown-trigger"
            >{{ 'Resources' | translate }}
            <img
              width="14"
              height="14"
              loading="eager"
              alt="resources arrow down"
              src="images/icons/arrow-down.svg"
          /></span>
          <ul class="dropdown-content" [class.hide]="isDropdownHidden">
            <li class="dropdown-item">
              <a
                [routerLink]="
                  language === 'en' ? ['/faq'] : ['/', language, 'faq']
                "
                routerLinkActive="active"
                class="link dropdown-item__link"
                >{{ 'FAQs' | translate }}</a
              >
              @if (hasBlog) {
                <a
                  [routerLink]="
                    language === 'en' ? ['/blog'] : ['/', language, 'blog']
                  "
                  routerLinkActive="active"
                  class="link dropdown-item__link"
                  >{{ 'Blog' | translate }}</a
                >
              }
              <a
                [routerLink]="
                  language === 'en'
                    ? ['/help']
                    : ['/', language, 'help']
                "
                routerLinkActive="active"
                class="link dropdown-item__link"
                >{{ 'Help center' | translate }}</a
              >
            </li>
          </ul>
        </li>
        <li class="navbar-pages__item">
          <a
            class="link"
            routerLinkActive="active"
            [routerLink]="
              language === 'en' ? ['/contact'] : ['/', language, 'contact']
            "
            >{{ 'Contact' | translate }}</a
          >
        </li>
        <li class="navbar-pages__item languages-mobile">
          <div class="languages languages-mobile">
            <ng-container *ngTemplateOutlet="languages"></ng-container>
          </div>
        </li>
      </ul>
      <div class="navbar-actions">
        <div class="languages languages-desktop">
          <ng-container *ngTemplateOutlet="languages"></ng-container>
        </div>
        @if (signedIn.user(); as user) {
          <!-- Signed in (Figma "account (signed-in client)"): initials, name and the firm when the reader's
               hub is known; opens CaseActive as Log In does. On a phone, the initials only. -->
          <button type="button" class="account" (click)="goToLogin()" [attr.aria-label]="user.name">
            <span class="account__avatar" aria-hidden="true">{{ user.initials }}</span>
            <span class="account__name">
              <span class="account__full-name">{{ user.name }}</span>
              @if (readerHub.firmName(); as firm) {
                <span class="account__firm">{{ firm }}</span>
              }
            </span>
            <svg class="account__chevron" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M4.5 6.75 9 11.25l4.5-4.5" stroke="#2E323C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        } @else {
          <button (click)="goToLogin()" class="tertiary">
            <span class="navbar-actions__text">{{ 'Log In' | translate }}</span>
            <img
              class="navbar-actions__img"
              width="32"
              height="32"
              src="images/icons/login.svg"
              loading="eager"
              alt="login"
            />
          </button>
          <button (click)="goToSignup()" class="primary get-started">
            {{ 'Start Free' | translate }}
          </button>
        }
        <button (click)="showHideMobileMenu()" class="navbar-actions__menu">
          <img
            width="32"
            height="32"
            src="images/icons/menu.svg"
            loading="eager"
            alt="menu"
          />
        </button>
      </div>
    </nav>
  </div>
</header>

<ng-template #languages>
  <app-select-language
    id="language"
    class="switchLanguage"
    [locale]="locale"
    [filteredLanguages]="filteredLanguages"
    [popularLanguages]="popularLanguages"
    (languageChange)="onLanguageChange()"
  />
</ng-template>
